import styled from '@emotion/styled'

export const ProductCellContainer = styled.div((props) => ({
  display:'flex',
  justifyContent:'space-between',

  '.ProductCellCard':{
    flex:1,
    justifyContent:'space-between',
    marginRight:'0.3em',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    display: 'flex',
    flexDirection: 'column',
    background: '#FFFFFF',
    boxShadow:'0 2px 2px 0 rgba(0, 0, 0, 0.1)',
    borderRadius:5,
    minHeight:80,
    padding:10,
    fontFamily:'IBM Plex Sans Thai',
    
    '&:hover':{
      cursor:'pointer',
      boxShadow:'0 4px 4px 0 rgba(0, 0, 0, 0.1)',
      backgroundColor: '#f9f9f9',
    },

    'p':{
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginBottom: 0,
    },

    'a': {
      textDecoration: 'none'
    }
  }

}))
